// eslint-disable-next-line import/no-unresolved
import store from '@/store'

const permisos = sessionStorage.getItem('permisos_auth')

/**
 * Returns ability result if ACL is configured or else just return true
 * Useful if you don't know if ACL is configured or not
 * Used in @core files to handle absence of ACL without errors
 */
export const can = permiso => {
  if (permisos === '*') {
    return true
  }
  if (permisos.includes(permiso)) {
    // PARA EVITAR Q EL AGENTE PUEDA CREAR MAS AGENTES
    if (store.state.app.userProfile.nivel === 2) {
      if (permiso !== 'agente:list') {
        return true
      }
    } else {
      return true
    }
  }

  return false
}

/* export const can = (permiso, permisos) => {
  const vm = getCurrentInstance().proxy

  return vm.can ? vm.can(permiso, permisos) : true
} */

/**
 * Check if user can view item based on it's ability
 * Based on item's action and resource
 * @param {Object} item navigation object item
 */
// eslint-disable-next-line no-undef
export const canViewVerticalNavMenuLink = item => can(item.permiso, permisos)

/**
 * Check if user can view item based on it's ability
 * Based on item's action and resource & Hide group if all of it's children are hidden
 * @param {Object} item navigation object item
 */
// eslint-disable-next-line arrow-body-style
export const canViewVerticalNavMenuGroup = item => {
  // ! This same logic is used in canViewHorizontalNavMenuGroup and canViewHorizontalNavMenuHeaderGroup. So make sure to update logic in them as well
  // eslint-disable-next-line no-undef
  const hasAnyVisibleChild = item.children.some(i => can(i.permiso, permisos))

  // If resource and action is defined in item => Return based on children visibility (Hide group if no child is visible)
  // Else check for ability using provided resource and action along with checking if has any visible child
  if (!(item.action && item.resource)) {
    return hasAnyVisibleChild
  }

  // eslint-disable-next-line no-undef
  return can(item.permiso, permisos) && hasAnyVisibleChild
}

/**
 * Check if user can view item based on it's ability
 * Based on item's action and resource
 * @param {Object} item navigation object item
 */
// eslint-disable-next-line no-undef
export const canViewVerticalNavMenuHeader = item => can(item.permiso, permisos)

/**
 * Check if user can view item based on it's ability
 * Based on item's action and resource
 * @param {Object} item navigation object item
 */
// eslint-disable-next-line no-undef
export const canViewHorizontalNavMenuLink = item => can(item.permiso, permisos)

/**
 * Check if user can view item based on it's ability
 * Based on item's action and resource
 * @param {Object} item navigation object item
 */
// eslint-disable-next-line no-undef
export const canViewHorizontalNavMenuHeaderLink = item => can(item.permiso, permisos)

/**
 * Check if user can view item based on it's ability
 * Based on item's action and resource & Hide group if all of it's children are hidden
 * @param {Object} item navigation object item
 */
// eslint-disable-next-line arrow-body-style
export const canViewHorizontalNavMenuGroup = item => {
  // ? Same logic as canViewVerticalNavMenuGroup
  // eslint-disable-next-line no-undef
  const hasAnyVisibleChild = item.children.some(i => can(i.permiso, permisos))

  // If resource and action is defined in item => Return based on children visibility (Hide group if no child is visible)
  // Else check for ability using provided resource and action along with checking if has any visible child
  if (!(item.permiso)) {
    return hasAnyVisibleChild
  }

  // eslint-disable-next-line no-undef
  return can(item.permiso, permisos) && hasAnyVisibleChild
}

// eslint-disable-next-line arrow-body-style
export const canViewHorizontalNavMenuHeaderGroup = item => {
  // ? Same logic as canViewVerticalNavMenuGroup but with extra content

  // eslint-disable-next-line arrow-body-style
  const hasAnyVisibleChild = item.children.some(grpOrItem => {
    // If it have children => It's grp
    // Call ACL function based on grp/link
    return grpOrItem.children ? canViewHorizontalNavMenuGroup(grpOrItem) : canViewHorizontalNavMenuLink(grpOrItem)
  })

  // If resource and action is defined in item => Return based on children visibility (Hide group if no child is visible)
  // Else check for ability using provided resource and action along with checking if has any visible child
  if (!(item.action && item.resource)) {
    return hasAnyVisibleChild
  }

  // eslint-disable-next-line no-undef
  return can(item.permiso, permisos) && hasAnyVisibleChild
}
